// Polyfill for Promise.withResolvers (ES2024)
// Required for older browsers that don't support this API
// Used by react-pdf/pdfjs-dist

// Type declaration for Promise.withResolvers
interface PromiseWithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
}

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): PromiseWithResolvers<T>;
  }
}

if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function <T>(): PromiseWithResolvers<T> {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}

// Required for TypeScript to treat this file as a module
export {};
